import { useQuery } from "@tanstack/react-query";
import { RoleShell, type RoleShellNavItem } from "./RoleShell";
import { companyApi } from "../lib/api";
import {
  HR_KYC_COPY,
  hrNeedsIdentityKyc,
  isCompanyAdmin,
  orgIsVerified,
  orgKycNavLabel,
} from "../lib/companyKyc";
import { NAV_COPY, NAV_ICONS } from "../lib/navCopy";

const NAV_SECTIONS = [
  {
    label: NAV_COPY.sections.hiring,
    items: [
      { to: "/hr/jobs/new", label: NAV_COPY.hr.postJob, icon: NAV_ICONS.postJob, exact: true },
      { to: "/hr/jobs", label: NAV_COPY.hr.jobs, icon: NAV_ICONS.jobs, exclude: "/hr/jobs/new" },
      { to: "/hr/templates", label: NAV_COPY.hr.hiringFlows, icon: NAV_ICONS.hiringFlows },
    ],
  },
  {
    label: NAV_COPY.sections.pipeline,
    items: [
      { to: "/hr/submissions", label: NAV_COPY.common.submissions, icon: NAV_ICONS.submissions },
      { to: "/hr/disputes", label: NAV_COPY.common.disputes, icon: NAV_ICONS.disputes },
    ],
  },
  {
    label: NAV_COPY.sections.company,
    items: [
      { to: "/hr/contract", label: NAV_COPY.common.rateCards, icon: NAV_ICONS.rateCards },
      { to: "/hr/team", label: NAV_COPY.hr.team, icon: NAV_ICONS.team },
    ],
  },
];

export function HrLayout() {
  const companyQuery = useQuery({ queryKey: ["my-company"], queryFn: companyApi.myCompany });
  const hrKycQuery = useQuery({ queryKey: ["hr-kyc"], queryFn: companyApi.hrKyc });
  const overviewItems: RoleShellNavItem[] = [
    { to: "/hr", label: NAV_COPY.common.dashboard, icon: NAV_ICONS.dashboard, end: true },
  ];
  if (
    isCompanyAdmin(companyQuery.data) &&
    !orgIsVerified(companyQuery.data?.verification_status)
  ) {
    overviewItems.push({
      to: "/hr/kyc",
      label: orgKycNavLabel(companyQuery.data?.verification_status),
      icon: NAV_ICONS.orgKyc,
    });
  }
  if (hrNeedsIdentityKyc(hrKycQuery.data) && !hrKycQuery.data?.kyc_bypass) {
    overviewItems.push({
      to: "/hr/identity",
      label: HR_KYC_COPY.pageTitle,
      icon: NAV_ICONS.kyc,
    });
  }

  const navSections = [{ label: NAV_COPY.sections.overview, items: overviewItems }, ...NAV_SECTIONS];

  return (
    <RoleShell
      portalLabel="HR Portal"
      logoTo="/hr"
      navSections={navSections}
      avatarFallback="H"
      profileTo="/hr/profile"
    />
  );
}
